// extracted by mini-css-extract-plugin
export default {"environment":"to9JH2whNf8crDayv6WE","hacks":"kzbwnQ1gRWhsuyEwDk4R","staging":"TYle71KELEubGCSrby31","fairfax":"DoUnXFcnzqcMZVksnfVe","fairfaxBanner":"EK65g9zhOsRM6Yj9tOOz"};